export const TRACK_EVENT = 'TRACK_EVENT'

export const trackEvent = (url, tracking) => {
    return {
        type: TRACK_EVENT,
        payload: {url, tracking}
    }
}





// WEBPACK FOOTER //
// ./src/actions/track.js